

























import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import InputProps from "@/mixins/InputProps";
import { getElement } from "@/lib/elementHelpers";
import { format, parse, isValid } from "@/lib/time";
import { InputMaskOptions } from "@/modules/inputMask";
import BaseInput from "@/components/BaseInput";

@Component({ name: "BaseInputTime", components: { BaseInput } })
export default class BaseInputTime extends InputProps {
  @Prop({ default: "hh:mm a" })
  public readonly timeFormat!: string;

  public support = true;

  public opts: InputMaskOptions = {
    showMaskOnHover: false,
    showMaskOnFocus: false,
    alias: "datetime",
    inputFormat: this.inputFormat,
    placeholder: this.placeHolder,
  };

  public get currentValue() {
    try {
      const date = parse(this.value, this.timeFormat, new Date());
      if (!isValid(date)) {
        return format(parse(this.value, "HH:mm", new Date()), this.timeFormat);
      }
    } catch (e) {}
    return this.value;
  }

  public get placeHolder() {
    return this.inputFormat.toUpperCase().replace("TT", "AM");
  }

  public get inputFormat() {
    return this.timeFormat
      .split("")
      .map(c => {
        if (c === "m") return "M";
        if (c === "a") return "TT";
        return c;
      })
      .join("");
  }

  public onInput(v: string) {
    const date = parse(v, this.timeFormat, new Date());
    if (isValid(date)) {
      this.$emit("input", format(date, "HH:mm"));
    } else this.$emit("input", v);
  }

  public mounted() {
    const el = getElement<HTMLInputElement>(this.$refs.input);
    this.support = el.type === "time";
  }
}
